import { render } from "./S940_AdminLieferantDokumentArchiv.vue?vue&type=template&id=811650e2&scoped=true&ts=true"
import script from "./S940_AdminLieferantDokumentArchiv.vue?vue&type=script&lang=ts"
export * from "./S940_AdminLieferantDokumentArchiv.vue?vue&type=script&lang=ts"

import "./S940_AdminLieferantDokumentArchiv.vue?vue&type=style&index=0&id=811650e2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-811650e2"]])

export default __exports__